<template>
    <div class='inline-auto-width'>
        <b-button class='small-bottom-margin transparent-border' size='sm' variant='outline-secondary' @click='copyCurrentUrl'><span class="glyphicon glyphicon-share"></span> Share</b-button>
        <b-modal auto-focus-button='ok' ref='urlCopiedModalRef' :title='"Page Link Copied"' ok-only @ok='handleModalOk' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                A link to this page has been copied for pasting into email or websites to share with others!
            </div>
        </b-modal>    
    </div>
</template>

<script>
export default {
    methods: {
        copyCurrentUrl() {
            let dummy = document.createElement('input')
            let text = window.location.href

            document.body.appendChild(dummy)
            dummy.value = text
            dummy.select()
            dummy.setSelectionRange(0, 99999) // For mobile devices
            document.execCommand('copy')
            document.body.removeChild(dummy)

            this.$refs.urlCopiedModalRef.show()
        },
        handleModalOk() {
            this.$refs.urlCopiedModalRef.hide()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ShareButton.vue